import { render } from "./shop.vue?vue&type=template&id=635a29e0&scoped=true"
import script from "./shop.vue?vue&type=script&lang=js"
export * from "./shop.vue?vue&type=script&lang=js"

import "./shop.vue?vue&type=style&index=0&id=635a29e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635a29e0"]])

export default __exports__